export const ACCOUNT_REWARDS_V1 = '/v1/account/rewards';
export const ACCOUNT_REWARD_OPTIONS = `${ACCOUNT_REWARDS_V1}/reward-options`;
export const ACCOUNT_REWARDS_EXPERIENCE = `${ACCOUNT_REWARDS_V1}/experience`;
